// extracted by mini-css-extract-plugin
export default {"socialButtons":"Gfbd09a","pageSocialButtons":"G36b9bf","componentSocialButtons":"G6c15b0","mobileHide":"Gd62db7","mobileShow":"G14f189"};